import React from 'react';
import UniversityCover from '../../assets/images/UniversityCover.jpg';
import UniversityLogo from '../../assets/images/UniversityLogo.png';

const MyUniversity = () => {
    return (
        <section className='overflow-hidden'>
            <h2 data-aos="flip-down" className='text-green-600 w-full text-center text-3xl md:text-4xl pt-20 pb-8 Black-Ops-One'>My University</h2>
            <div className="hero h-80 relative font-Cormorant-Garamond mb-5 border-y-[1px] border-gray-600" style={{ backgroundImage: `url(${UniversityCover})` }}>
                <div className="hero-overlay bg-opacity-80 bg-[#02162b]" data-aos="fade" data-aos-duration="400" ></div>
                <div className="hero-content max-w-full capitalize text-left flex justify-around w-full">
                    <div className="p-0 md:pl-10 2xl:pl-0 " data-aos="fade-right" data-aos-duration="1000">
                        <h1 className="mb-3 text-2xl font-bold">Daffodil International University</h1>
                        <p className="mb-0 sm:mb-2 text-sm md:text-lg">Campus: Daffodil Smart City, Ashulia, Dhaka, Bangladesh.</p>
                        <p className="mb-0 sm:mb-2 text-sm md:text-lg">Department: Computer Science And Engineering</p>
                        <p className="mb-0 sm:mb-2 text-sm md:text-lg">Timeline: September 2017 - December 2021</p>
                        <p className="mb-0 sm:mb-2 text-sm md:text-lg">CGPA: 3.21 out of 4</p>
                        <a
                            target={'blank'}
                            href="https://daffodilvarsity.edu.bd/"
                            className='mb-1 mt-4 btn btn-sm  capitalize md:w-48 h-8 md:h-9 font-play font-light rounded text-xs md:text-sm  text-green-400 hover:text-white bg-[#00283ac9] hover:bg-green-600 transition duration-150 ease-in-out border-[1px] border-green-900 hover:border-green-600'>
                            Visite Offcial Website
                        </a>
                    </div>
                    <a data-aos="fade-left" data-aos-duration="500" target={'blank'} className='bg-[#ffffff30] rounded-2xl border border-gray-700 hidden lg:block' href="https://daffodilvarsity.edu.bd/">
                        <div className='w-32 h-32 flex flex-col justify-center items-center' >
                            <img src={UniversityLogo} alt="" />
                        </div>
                    </a>
                </div>
            </div>
        </section>
    );
};

export default MyUniversity;